/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Packing_List_InvalidInputs */

const en_error_packing_list_invalid = /** @type {(inputs: Error_Packing_List_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some lines of the packing list are not lines of this inbound.`)
};

/**
* | output |
* | --- |
* | "Some lines of the packing list are not lines of this inbound." |
*
* @param {Error_Packing_List_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_packing_list_invalid = /** @type {((inputs?: Error_Packing_List_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Packing_List_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_packing_list_invalid(inputs)
});